import useAxios from 'hooks/useAxios';

export async function updateStreamingConfig(payload) {
  const api = useAxios();

  try {
    const res = await api.patch('/streaming-config', payload);
    return res;
  } catch (err) {
    return err;
  }
}
